import { Rocket, ShieldCheck, Layers, Clock4, Cpu, Code2 } from "lucide-react";

const items = [
  { id: "fast", icon: Rocket, label: "Fast Delivery" },
  { id: "secure", icon: ShieldCheck, label: "Secure Systems" },
  { id: "scale", icon: Layers, label: "Scalable Apps" },
  { id: "support", icon: Clock4, label: "24 / 7 Support" },
  { id: "stack", icon: Cpu, label: "Modern Stack" },
  { id: "clean", icon: Code2, label: "Clean Code" },
];

export default function TrustBar() {
  const list = [...items, ...items];
  return (
    <section data-testid="trust-bar" className="relative py-12 border-y border-[#eef0f5] bg-paper-soft">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="text-center text-[11px] sm:text-xs uppercase tracking-[0.28em] text-[#6b7280] mb-6 font-mono-d">
          Trusted standard for modern product teams
        </div>
        <div className="mask-fade overflow-hidden">
          <div className="flex gap-10 sm:gap-14 animate-marquee whitespace-nowrap">
            {list.map((it, i) => {
              const Icon = it.icon;
              return (
                <div
                  key={`${it.id}-${i}`}
                  data-testid={`trust-item-${it.id}-${i}`}
                  className="inline-flex items-center gap-3 text-[#1f2937]"
                >
                  <span className="grid place-items-center w-9 h-9 rounded-xl surface">
                    <Icon className="w-4 h-4 text-[#0066ff]" />
                  </span>
                  <span className="text-sm font-semibold tracking-tight">{it.label}</span>
                  <span className="w-1 h-1 rounded-full bg-[#cbd2dc] ml-4" />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
